import React, { useState, useEffect, useContext } from "react";
import { RouteProps, useLocation } from "react-router-dom";
import PubSub from "pubsub-js";
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonIcon,
  IonButton,
  IonTitle,
  IonChip,
} from "@ionic/react";
import UserSettingsModal from "../pages/UserSettingsModal";
import { pubsubEvents } from "../components/helpers/socket/pubsubEvent";
import LogoutButton from "../components/helpers/LogoutButton";
import { hapticsImpactMedium } from "../utils/core-utils/hapticUtils";
import { notificationsOutline } from "ionicons/icons";
import UserIcon from "../theme/custom-icons/User.svg";
import { FE_URL } from "../utils/urlUtils";
import NotificationsModal from "../pages/NotificationsModal";
import BeaconAccessContext from "../components/contexts/BeaconAccessContext";
import firebaseEventConfig from "../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../utils/firebaseAnalytics/firebaseUtils";

// @author E42303 Judhjit Ganguli

interface DesktopHeaderProps extends RouteProps {
  entitlements: string[] | undefined;
  isUserTermsConditionAccepted: any;
  isCMEDProfileSelectionCompleted: any;
  isUserSettingsModalOpen: any;
  setIsUserSettingsModalOpen: any;
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  entitlements,
  isUserTermsConditionAccepted,
  isCMEDProfileSelectionCompleted,
  isUserSettingsModalOpen,
  setIsUserSettingsModalOpen,
}) => {
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false);
  const { hasBeaconAccess } = useContext(BeaconAccessContext);
  const [isCMEDLoggedIn, setisCMEDLoggedIn] = useState(false);

  useEffect(() => {
    PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_ORDER_USER_DETAILS_UPDATE,
      (data, res) => {
        updateCMEDUserEntitlements(data, res);
      },
    );

    const isLoggedInToken = PubSub.subscribe(
      pubsubEvents.stompSubscriptionKeys.CMED_USER_LOGON_SUCCESS,
      (msg, data) => {
        setisCMEDLoggedIn(data.payload.isLoggedIn);
      },
    );

    return () => {
      PubSub.unsubscribe(isLoggedInToken);
    };
  }, []);

  async function updateCMEDUserEntitlements(data: any, res: any) {
    setLoggedInUserDetails(res.payload.data[0]);
  }

  let env;
  if (FE_URL?.includes("uat")) {
    env = "UT";
  } else if (FE_URL?.includes("prod")) {
    env = undefined;
  } else if (FE_URL?.includes("qa")) {
    env = "QA";
  } else if (FE_URL?.includes("dev")) {
    env = "DEV";
  } else {
    env = "LOCAL";
  }

  const location = useLocation();
  const isCmedPath = location.pathname.includes("cmed");

  return (
    <>
      {isCmedPath && (
        <IonHeader className="ion-no-border">
          <IonToolbar className="ion-no-padding cmed_mobile_toolbar">
            <IonTitle className="custom_title_cmed_mobile">
              CME Direct {env && <IonChip color={"danger"}>{env}</IonChip>}
            </IonTitle>
            {isUserTermsConditionAccepted && (
              <IonButtons slot="end" style={{ marginRight: "10px" }}>
                {entitlements?.includes("CMED") ? (
                  <>
                    {hasBeaconAccess && isCMEDLoggedIn && (
                      <IonButton
                        color={"dark"}
                        id="notificationsHeader"
                        style={{ marginRight: "15px" }}
                        onClick={() => {
                          hapticsImpactMedium();
                          setIsNotificationsModalOpen(true);
                          CMEDfirebaseLogEvent(
                            firebaseEventConfig.CMEDComponentNames.CMED_BEACON,
                            firebaseEventConfig.eventNames.CMED_BEACON
                              .CMED_BEACON_VIEW_MANAGE_ALERTS_WINDOW,
                          );
                        }}
                      >
                        <IonIcon
                          style={{ fontSize: "22px" }}
                          icon={notificationsOutline}
                        />
                      </IonButton>
                    )}
                    <IonButton
                      color={"dark"}
                      id="settingsHeader"
                      onClick={() => setIsUserSettingsModalOpen(true)}
                    >
                      <IonIcon
                        style={{ fontSize: "20px" }}
                        icon={UserIcon}
                        onClick={hapticsImpactMedium}
                      />
                    </IonButton>
                  </>
                ) : (
                  <LogoutButton />
                )}
              </IonButtons>
            )}
          </IonToolbar>
        </IonHeader>
      )}
      <UserSettingsModal
        isUserSettingsModalOpen={isUserSettingsModalOpen}
        setIsUserSettingsModalOpen={setIsUserSettingsModalOpen}
        loggedInUserDetails={loggedInUserDetails}
        entitlements={entitlements}
        isCMEDProfileSelectionCompleted={isCMEDProfileSelectionCompleted}
      />
      {hasBeaconAccess && isCMEDLoggedIn && (
        <NotificationsModal
          isNotificationsModalOpen={isNotificationsModalOpen}
          setIsNotificationsModalOpen={setIsNotificationsModalOpen}
        />
      )}
    </>
  );
};
export default DesktopHeader;
